import { useState, useEffect } from 'react';
import { UserHttpService } from 'core/services/user';

const useJobExperienceForm = (id) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    useEffect(() => {
        const loadJobExperience = async () => {
            if (!id) return;
            
            setIsLoading(true);
            setError(null);
            
            try {
                const response = await UserHttpService.getJobExperience(id);
                setData(response.data);
            } catch (err) {
                setError(err.message || 'Failed to load job experience');
            } finally {
                setIsLoading(false);
            }
        };

        loadJobExperience();
    }, [id]);

    const saveJobExperience = async (formData) => {
        setIsLoading(true);
        setError(null);

        try {
            const jobExperienceData = {
                title: formData.title,
                company_title: formData.company_title,
                description: formData.description,
                start_date: formData.start_date,
                end_date: formData.end_date,
                cv: formData?.cv ?? null
            };
            
            if (id) {
                await UserHttpService.updateJobExperience(id, jobExperienceData);
            } else {
                await UserHttpService.createJobExperience(jobExperienceData);
            }
        } catch (err) {
            setError(err.message || 'Failed to save job experience');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        error,
        data,
        saveJobExperience
    };
};

export default useJobExperienceForm; 